<template>
    <div class="vue-accordion" :class="{'is-open': open}">
        <div class="accordion-title">
            <button
                @click="open = ! open"
                @keydown.esc="open = false"
                :aria-expanded="open ? 'true' : 'false'"
                :aria-controls="bodyID"
                :id="headingID">
                <slot name="title"></slot>
            </button>
        </div>

        <div class="accordion-body" v-show-slide="open" :aria-labelledby="headingID" :id="bodyID" >
            <slot name="body"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Accordion",

    data() {
        return {
            open: false
        }
    },

    computed: {
        headingID() {
            return _.uniqueId('accordion-header-');
        },

        bodyID() {
            return _.uniqueId('accordion-body-');
        }
    }
}
</script>